var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page d-flex flex-column align-items-center"},[_c('div',{staticClass:"container d-flex justify-content-center align-items-start flex-grow-1 pt-5"},[_c('Otp')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }